/* eslint-disable no-restricted-syntax */
/* eslint-disable import/prefer-default-export */

// error msg
export const errMsg = 'Something went wrong! Please try again.';
export const noAbsenceToClear = `There are currently no absences to clear 
for this student.`;
export const noAbsenceToConfirm = `There are no pending teacher absences 
to confirm for this student.`;
export const noAbsenceToClearOrConfirm = `There are currently no pending 
absences to clear or confirm for this student.`;

// info msg
export const absencesNotConfirmedMsg = `The following absences are currently in "Review"
 and are not yet available to clear until the period teacher has verified the absence. You can 
 expect a notification email once all pending periods have been verified by the teacher.`;

export const formatMessage = (msg) => {
  const fieldNameObj = {
    early_leave_code: '\'Reason\'',
    alternate_phone: '\'Alternate Phone\'',
    release_time: '\'Release Time\'',
    leave_date: '\'Leave Date\'',
    period: '\'Period\'',
  };
  let string = msg;
  for (const [key, value] of Object.entries(fieldNameObj)) {
    let data = '';
    if (string.includes(key)) {
      data = string.replace(key, value);
      string = data;
    }
  }
  return string;
};
